import { sudokuGrid } from "@lib/static-content"
import { useEffect } from "react"

const sudokuLink = "https://sudokupad.app/n4qHMLbtTd"

export function Sudoku() {
  useEffect(() => {
    let scrollPos = 0
    let scrollMomentum = 0

    const isScrolledToBottom = () => {
      scrollMomentum = window.scrollY - scrollPos
      scrollPos = window.scrollY
      return window.innerHeight + window.scrollY >= document.body.offsetHeight
    }

    const executeWhenScrolledToBottom = () => {
      const el = document.querySelector<HTMLElement>("#sudoku")
      if (!el) return
      el.classList.add("bump")
      el.style.setProperty("--momentum", `${scrollMomentum}px`)

      window.setTimeout(() => {
        el.classList.remove("bump")
      }, 1000)
    }

    const handleScroll = () => {
      if (isScrolledToBottom()) executeWhenScrolledToBottom()
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <div
      className="relative mt-[-100px] h-[300px] overflow-hidden"
      data-id="sudoku-container"
    >
      <div
        className="absolute right-1/2 bottom-[-40px] rotate-[-15deg] [--momentum:400px] [&.bump]:[animation:bump_0.3s_ease-out_1]"
        data-id="sudoku"
        id="sudoku"
      >
        <a
          className="no-underline opacity-30 hover:opacity-60"
          data-id="sudoku-link"
          href={sudokuLink}
          target="_blank"
          rel="noreferrer"
        >
          <div
            className="grid h-[var(--cell-size-9)] w-[var(--cell-size-9)] grid-cols-9 grid-rows-9 border-[var(--white)] border-r-2 border-b-2 [--cell-size-3:calc(var(--cell-size)*3)] [--cell-size-9:calc(var(--cell-size)*9)] [--cell-size:30px] [background-image:linear-gradient(to_right,var(--white-50)_1px,transparent_1px),linear-gradient(to_bottom,var(--white-50)_1px,transparent_1px),linear-gradient(to_right,var(--white)_2px,transparent_1px),linear-gradient(to_bottom,var(--white)_2px,transparent_1px)] [background-size:var(--cell-size)_var(--cell-size),var(--cell-size)_var(--cell-size),var(--cell-size-3)_var(--cell-size-3),var(--cell-size-3)_var(--cell-size-3)]"
            data-id="sudoku-grid"
          >
            {sudokuGrid.map((cell) => (
              <div
                className="text-center text-[calc(var(--cell-size)*0.8)] text-[var(--white)] leading-[var(--cell-size)]"
                data-id={`sudoku-cell-${cell.row}-${cell.col}`}
                key={`${cell.row}-${cell.col}`}
                style={{
                  gridColumn: `${cell.col.replace("col-", "")} / span 1`,
                  gridRow: `${cell.row.replace("row-", "")} / span 1`,
                }}
              >
                {cell.value}
              </div>
            ))}
            <div
              className="mt-[3px] mr-[1px] mb-0 ml-[4px] border border-[var(--white)] border-dashed"
              style={{ gridColumn: "5 / span 1", gridRow: "5 / span 2" }}
            />
            <div
              className="mt-[3px] mr-0 mb-0 ml-[5px] border border-[var(--white)] border-dashed"
              style={{ gridColumn: "7 / span 1", gridRow: "6 / span 1" }}
            />
          </div>
        </a>
      </div>
    </div>
  )
}

export default Sudoku
